<template>
  <div class="flex flex-col gap-2">
    <!-- Toolbar -->
    <div class="flex gap-2 mb-2 flex-wrap">
      <button
        type="button"
        @click="editor.chain().focus().toggleBold().run()"
        :class="{'font-bold bg-gray-200': editor.isActive('bold')}"
        class="px-2 py-1 border rounded"
      >B</button>

      <button
        type="button"
        @click="editor.chain().focus().toggleItalic().run()"
        :class="{'italic bg-gray-200': editor.isActive('italic')}"
        class="px-2 py-1 border rounded"
      >I</button>

      <button
        type="button"
        @click="editor.chain().focus().toggleUnderline().run()"
        :class="{'underline bg-gray-200': editor.isActive('underline')}"
        class="px-2 py-1 border rounded"
      >U</button>

      <button
        type="button"
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
        :class="{'bg-gray-200': editor.isActive('heading', { level: 1 })}"
        class="px-2 py-1 border rounded"
      >H1</button>

      <button
        type="button"
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
        :class="{'bg-gray-200': editor.isActive('heading', { level: 2 })}"
        class="px-2 py-1 border rounded"
      >H2</button>

      <button
        type="button"
        @click="editor.chain().focus().toggleHighlight().run()"
        :class="{'bg-yellow-200': editor.isActive('highlight')}"
        class="px-2 py-1 border rounded"
      >Highlight</button>

      <button
        type="button"
        @click="editor.chain().focus().toggleCodeBlock().run()"
        :class="{'bg-gray-200': editor.isActive('codeBlock')}"
        class="px-2 py-1 border rounded"
      >Code</button>
    </div>

    <!-- Editor -->
    <EditorContent
      :editor="editor"
      class="border rounded-lg p-2 min-h-[150px] max-h-[300px] overflow-y-auto focus:ring focus:ring-blue-200"
    />
  </div>
</template>

<script setup>
import { onBeforeUnmount, watch } from "vue"
import { Editor, EditorContent } from "@tiptap/vue-3"
import StarterKit from "@tiptap/starter-kit"
import Underline from "@tiptap/extension-underline"
import Highlight from "@tiptap/extension-highlight"
import CodeBlock from "@tiptap/extension-code-block"

const props = defineProps({
  modelValue: { type: String, default: "" },
})

const emit = defineEmits(["update:modelValue"])

// Initialize the editor
const editor = new Editor({
  content: props.modelValue || "",
  extensions: [StarterKit, Underline, Highlight, CodeBlock],
  onUpdate({ editor }) {
    emit("update:modelValue", editor.getHTML())
  },
})

// Watch for external updates to modelValue
watch(
  () => props.modelValue,
  (val) => {
    if (editor.getHTML() !== val) {
      editor.commands.setContent(val || "")
    }
  }
)

// Destroy editor when component unmounts
onBeforeUnmount(() => editor.destroy())
</script>
